module.exports = __webpack_public_path__ + "img/widget-social-rewards.4b3b0a0c.svg";